module.exports = __webpack_public_path__ + "img/poster-intro.1cfe6e60.jpg";